// "Found by" badges for houses surfaced by Buy Box Agents:
// `Agent 2 · V1 · Las Vegas, NV`, one per agent that found the house.

import { Bot } from "lucide-react";
import { buyBoxAgentTagText } from "@shared/buy-box-agents";
import type { BuyBoxAgentTag } from "@shared/schema";

export function BuyBoxAgentTags({ tags, testId }: { tags: BuyBoxAgentTag[] | null | undefined; testId?: string }) {
  if (!tags || tags.length === 0) return null;
  const seen = new Set<string>();
  const unique = tags.filter((t) => {
    const k = `${t.agentId ?? t.agentNumber}:${t.versionId ?? t.versionNumber}:${t.city}:${t.state}`;
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
  return (
    <div className="flex flex-wrap gap-1 mt-1" data-testid={testId}>
      {unique.map((t, i) => (
        <span
          key={i}
          className="inline-flex items-center gap-1 rounded bg-blue-50 px-1.5 py-0.5 text-[11px] font-medium text-blue-700"
          title={t.versionLabel ? `Buy Box V${t.versionNumber} (${t.versionLabel}) · run ${t.runDate}` : `Run ${t.runDate}`}
        >
          <Bot className="h-3 w-3" />
          {buyBoxAgentTagText(t)}
        </span>
      ))}
    </div>
  );
}
